import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';

export const useClientActivationHistory = ({ contactId, adapter }) => {
    const { t } = useTranslation();

    const {
        data: response,
        isLoading,
        error,
        refetch: getData,
    } = useGetCustomService({
        service: 'contactActivation',
        api: 'getContactActivationHistory',
        payload: { contactId },
        enabled: !!contactId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
    });

    const contactActivationHistory = useMemo(() => response?.data || [], [response]);

    const isLastResend24hAgo = useMemo(() => {
        const lastResendActivationCode = contactActivationHistory
            ?.filter((item) => [1, 2].includes(item?.activationStatus))
            ?.reverse()?.[0]?.modifiedDate;

        return lastResendActivationCode
            ? moment.utc(lastResendActivationCode).add(24, 'h') < moment.utc()
            : true;
    }, [contactActivationHistory]);

    const isUserRegistered = useMemo(
        () => contactActivationHistory.some((item) => item?.activationStatus === 6),
        [contactActivationHistory],
    );

    const data = useMemo(
        () => (contactActivationHistory.length > 0 ? adapter({ data: contactActivationHistory, t }) : undefined),
        [contactActivationHistory, t, adapter],
    );

    return {
        isLastResend24hAgo,
        isUserRegistered,
        data,
        getData,
        isLoading,
        error,
    };
};
